/* Auto-generated by scripts/fetch-judgeme-reviews.js — do not edit by hand. */
/* Generated at: 2026-10-04T15:22:07.556Z */
window.jrReviewsData = {
  "heal-seal-trio": {
    "productId": 8644190371919,
    "productTitle": "Heal & Seal Trio",
    "reviews": [
      {
        "id": 1361874194,
        "rating": 5,
        "title": "",
        "body": "I seen this on Instagram and wanted to try it i have been using it for 4 days and already notice a difference. it came within 2 days and i really like it.",
        "name": "Customer",
        "created_at": "2026-10-03T00:04:58+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1361814122,
        "rating": 5,
        "title": "",
        "body": "This is my first time buying skincare that is not my wife's products. Notice some important on the dark areas around my eyes and neck. Feel that my skin on my forehead and nose feels smooth and clean. But I am hoping that with more time applying the skin treatment, my skin should look and feel lighter and cleaner.",
        "name": "Steven German",
        "created_at": "2026-10-02T22:03:55+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1361770562,
        "rating": 5,
        "title": "",
        "body": "My skin is very sensitive so finding an aging care routine has been challenging. I absolutely love this trio of products. My skin has never been so clear. My lines have become softer for sure. I will definitely be continuing with the exfoliating pads, the toner pads along with the moisturizer. I am so pleased I tried them!",
        "name": "Julie Driggers",
        "created_at": "2026-10-02T19:56:05+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1361625698,
        "rating": 5,
        "title": "",
        "body": "I’m 80 years old and never paid attention to skin care until I saw the difference between me and my friends who did take care of their faces.  While I will never lose the wrinkles on my face, it does feel fresher and not dry. I’m hoping your product will eventually help erase the dark spots on my face.",
        "name": "Thelma E.",
        "created_at": "2026-10-02T16:54:30+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1354799816,
        "rating": 5,
        "title": "",
        "body": "Absolutely love these products .",
        "name": "Cheryl Marx",
        "created_at": "2026-09-27T17:52:49+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1353208526,
        "rating": 5,
        "title": "",
        "body": "right with first application I could feel the suppleness of skin and it stayed hydrated the whole day.",
        "name": "Customer",
        "created_at": "2026-09-26T13:09:04+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1352097842,
        "rating": 5,
        "title": "",
        "body": "LOVE!",
        "name": "Customer",
        "created_at": "2026-09-25T20:17:10+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1345207750,
        "rating": 5,
        "title": "",
        "body": "I like the pads and the cream. Don’t see too much difference yet, but hoping to soon. Thank you!",
        "name": "Barbara Teele",
        "created_at": "2026-09-20T21:38:54+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  },
  "nad-anti-aging-moisturizing-cream": {
    "productId": 7935970246735,
    "productTitle": "Anti-Aging Moisturizing Cream",
    "reviews": [
      {
        "id": 1356571898,
        "rating": 5,
        "title": "",
        "body": "Leaves my skin feeling soft and moisturized without making it feel greasy.",
        "name": "Patricia R Johnson",
        "created_at": "2026-09-28T23:45:15+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1352179185,
        "rating": 5,
        "title": "",
        "body": "I get a facial every five weeks and she asked me what I have done as she noticed the structure of my skin seems different. I love this stuff",
        "name": "James K.",
        "created_at": "2026-09-25T22:14:29+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1331298436,
        "rating": 5,
        "title": "",
        "body": "I lovr absolutely love this product.",
        "name": "Allison Morrissey",
        "created_at": "2026-09-13T16:48:54+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1316865617,
        "rating": 5,
        "title": "",
        "body": "I saw a utube and thought interesting. Saw the before and after. I’m about two weeks in and I notice a difference in the first few days. I’m 65 and love the product.",
        "name": "Customer",
        "created_at": "2026-08-31T20:08:33+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1307349271,
        "rating": 5,
        "title": "",
        "body": "Love love lovvveee! I’ve been using the indigo cream by Tatcha for years, and this is seriously up and up! Plus almost half the price 😁",
        "name": "Anonymous",
        "created_at": "2026-08-23T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1306059189,
        "rating": 5,
        "title": "",
        "body": "I. love this cream , it's cleared my skin and made my skin look younger  moisturizing love it thank you.",
        "name": "Norah N.",
        "created_at": "2026-08-23T01:06:29+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1307349269,
        "rating": 5,
        "title": "",
        "body": "So awesome great product",
        "name": "Anonymous",
        "created_at": "2026-08-22T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1304951829,
        "rating": 5,
        "title": "",
        "body": "Excellent product that makes the skin glow",
        "name": "Michelle E.",
        "created_at": "2026-08-22T02:01:27+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  },
  "polish-pads": {
    "productId": 8644190339151,
    "productTitle": "Cleansing Polish Pads",
    "reviews": [
      {
        "id": 1303180269,
        "rating": 5,
        "title": "",
        "body": "Just an amazing product!",
        "name": "Anonymous",
        "created_at": "2026-08-18T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180270,
        "rating": 5,
        "title": "",
        "body": "All the all the pimples that I have is dry and cleaning my skin",
        "name": "Anonymous",
        "created_at": "2026-08-16T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180272,
        "rating": 5,
        "title": "",
        "body": "These are great when your having a acne breakout. Just remember to rinse your face after use.",
        "name": "Anonymous",
        "created_at": "2026-08-15T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180382,
        "rating": 5,
        "title": "",
        "body": "I’m was very impressed how smooth and shiny my skin was after using just one time! Excellent exfoliating cleansing pads!👌🥰",
        "name": "Anonymous",
        "created_at": "2026-08-15T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180381,
        "rating": 5,
        "title": "",
        "body": "I cannot wait to use it Korean based skin care with the central ingredients amazing",
        "name": "Anonymous",
        "created_at": "2026-08-14T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180385,
        "rating": 5,
        "title": "",
        "body": "This product is so good. I’m so happy now purchase it. I’m very satisfied with this product.",
        "name": "Anonymous",
        "created_at": "2026-08-12T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180383,
        "rating": 5,
        "title": "",
        "body": "The best",
        "name": "Anonymous",
        "created_at": "2026-08-11T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180384,
        "rating": 5,
        "title": "",
        "body": "I really like this product.  It really deep cleans my pores and face.",
        "name": "Anonymous",
        "created_at": "2026-08-11T22:00:00+00:00",
        "verified": false,
        "pictures": []
      }
    ]
  },
  "pore-reset-duo": {
    "productId": 8644190437455,
    "productTitle": "Pore Reset Duo",
    "reviews": [
      {
        "id": 1330019911,
        "rating": 5,
        "title": "",
        "body": "One use this morning I can only tell it. It's a great product.",
        "name": "Joseph Romero",
        "created_at": "2026-09-12T00:57:50+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1298939839,
        "rating": 5,
        "title": "",
        "body": "Just started using so dont know how effective",
        "name": "Jacqueline Hernandez",
        "created_at": "2026-08-18T03:09:04+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1288604647,
        "rating": 5,
        "title": "",
        "body": "Arrived quickly. Now I just need to try it out.",
        "name": "patricia cortez",
        "created_at": "2026-08-07T22:13:07+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1309871566,
        "rating": 5,
        "title": "",
        "body": "Feels so nice in my skin.",
        "name": "Customer",
        "created_at": "2026-07-31T17:36:45+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1264499091,
        "rating": 5,
        "title": "",
        "body": "Seems fantastic so fsr! First morning trying it..",
        "name": "Rachael Genicoff",
        "created_at": "2026-07-20T14:45:53+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  },
  "renewal-rejuvenation-toner-pads": {
    "productId": 7935974375503,
    "productTitle": "Renewal & Rejuvenation Toner Pads",
    "reviews": [
      {
        "id": 1363454911,
        "rating": 5,
        "title": "",
        "body": "This is one of the most amazing products I have ever used. It has cleared my skin and continues to work, maintaining that clarity and targeting some skin imperfections and pigmentation issues I have. I highly recommend it for anyone 50+. be consistent with it and you will see results.",
        "name": "Soto",
        "created_at": "2026-10-04T14:41:49+00:00",
        "verified": true,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1791124909__image__original.jpg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1362780675,
        "rating": 5,
        "title": "",
        "body": "No problem with delivery. Product received as described.",
        "name": "Dorothy Chin",
        "created_at": "2026-10-03T22:06:35+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1356808320,
        "rating": 5,
        "title": "",
        "body": "I love how soft and smooth my skin feels!",
        "name": "Lorie S.",
        "created_at": "2026-09-29T01:38:33+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1356533261,
        "rating": 5,
        "title": "",
        "body": "Not too strong but definitely exfoliates. Nice smell. I like these.",
        "name": "Elizabeth Boguniecki",
        "created_at": "2026-09-28T23:25:24+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1356467831,
        "rating": 5,
        "title": "",
        "body": "I’ve only had this product for about a week now, but I’m already seeing changes that I really like",
        "name": "Customer",
        "created_at": "2026-09-28T22:46:18+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1353202553,
        "rating": 5,
        "title": "",
        "body": "I can see a difference in my texture of my skin and it’s getting a lighter color ! \r\nThank you for your product, I’ll be using it longer to see more difference !",
        "name": "Betty M.",
        "created_at": "2026-09-26T13:09:37+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1352372146,
        "rating": 5,
        "title": "",
        "body": "Love it 🥰",
        "name": "Trezer Owino",
        "created_at": "2026-09-26T00:57:14+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1352177717,
        "rating": 5,
        "title": "",
        "body": "Have used so many skin care products over the years and at 75, I swear, these have been the best",
        "name": "James K.",
        "created_at": "2026-09-25T22:12:44+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  },
  "test-complete-care-bundle": {
    "productId": 7935965265999,
    "productTitle": "Anti-Aging Glow-Up Bundle",
    "reviews": [
      {
        "id": 1360837692,
        "rating": 5,
        "title": "",
        "body": "I decided to try the Jiyu toner and moisturizer and I am so happy I did! I have been using it for a month now and noticed that my skin feels and looks rejuvenated. I have been on the hunt for new skincare products and I'm glad I finally found this brand, it is exactly what I was looking for. The moisturizer is amazing. It leaves my skin feeling smooth and gives it a dewey look. I also love the packaging. I will be reordering this product as it is now part of my new skincare routine!",
        "name": "Roxy S.",
        "created_at": "2026-10-02T01:19:46+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1357738586,
        "rating": 5,
        "title": "",
        "body": "Been using the toner pads and cream for 1 month and have seen a big improvement on my face my dark spots have faded, my pores have even shrunk, and my face has a glow to it. My next order I will order the 3 bundle and try all of them I do believe this product works!",
        "name": "Rosa S.",
        "created_at": "2026-09-29T14:50:43+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1356158741,
        "rating": 5,
        "title": "",
        "body": "Love this product",
        "name": "Cathy ONeill",
        "created_at": "2026-09-28T16:46:06+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1352366583,
        "rating": 5,
        "title": "",
        "body": "I can see the difference!!! My skin no longer dry, it feels hydrated and soft. Eyes less puffy and lines on my forehead less noticeable. People keep saying my skin is glowing :)",
        "name": "Marisol Romero",
        "created_at": "2026-09-26T00:59:21+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1352110820,
        "rating": 5,
        "title": "",
        "body": "Since I started using the toner pads and the moisturizer cream, my skin has improved and I haven’t been dealing with blemishes. Recommend these products",
        "name": "Cintya Z.",
        "created_at": "2026-09-25T20:41:53+00:00",
        "verified": true,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1790368913__img_8131__original.jpeg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1352049653,
        "rating": 5,
        "title": "",
        "body": "My skin is looking much better , healthier and glowing. Far  exceeding my expectations. I recommend. It’s gentle and effective.",
        "name": "Monique A.",
        "created_at": "2026-09-25T18:40:02+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1350647944,
        "rating": 5,
        "title": "",
        "body": "Oh my goodness, this is the best product I’ve ever used on my face! I absolutely love it, and my son Alvin does too. He plays baseball and football, and his skin tends to get oily. This product has made a tremendous difference in his skin. We’re both so happy with it!",
        "name": "Tamisha Thomas",
        "created_at": "2026-09-24T15:11:49+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1349125808,
        "rating": 5,
        "title": "",
        "body": "It really helped my skin, my pores are smaller and I look younger",
        "name": "Yvette Avila",
        "created_at": "2026-09-23T19:53:58+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  }
};
window.jrReviewsGeneratedAt = "2026-10-04T15:22:07.556Z";
